import React from 'react';
import { Route } from 'react-router';
import { Switch } from 'react-router-dom';
import NotFound from '../core/components/404';
import DetergentsRoute from './DetergentsRoute';
import Detergents from '../views/detergents';
import MyCharts from '../views/overview/containers/Charts';
import AnalyticsRoute from './AnalyticsRoute';
import ClaimsRoute from './ClaimsRoute';
import ClaimsOldRoute from './ClaimsOldRoute';
import EmployeeRoute from './EmployeeRoute';
import InventoryRoute from './InventoryRoute';
import RewashesRoute from './RewashesRoute';
import SettingsRoute from './SettingsRoute';
import SiteDispatcher from './SiteDispatcher';
import TasksRoute from './TasksRoute';
import TasksV2Route from './TasksV2Route';
import ProjectsRoute from './ProjectsRoute';
import WashCountsRoute from './WashCountsRoute';
import MaintenanceTasksRoute from './MaintenanceTasksRoute';
import UtilitiesRoute from './UtilitiesRoute';
import PurchasesRoute from './PurchasesRoute';

const siteRouteMap = {
  overview: MyCharts,
  detergents: Detergents,
  washcounts: WashCountsRoute,
  purchases: PurchasesRoute,
  utilities: UtilitiesRoute,
  analytics: AnalyticsRoute,
  tasks: TasksRoute,
  'tasks-v2': TasksV2Route,
  projects: ProjectsRoute,
  maintenance: MaintenanceTasksRoute,
  claims: ClaimsRoute,
  'claims-old': ClaimsOldRoute,
  team: EmployeeRoute,
  inventory: InventoryRoute,
  rewashes: RewashesRoute,
  settings: SettingsRoute,
};

const SiteRoute = () => {
  const siteRouteKeys = Object.keys(siteRouteMap);

  const getSiteRoute = (key) => {
    return <Route key={key} path={`/:site/${key}`} component={siteRouteMap[key]} />;
  };

  return (
    <SiteDispatcher>
      <Switch>
        {siteRouteKeys.map(getSiteRoute)}
        <Route component={NotFound} />
      </Switch>
    </SiteDispatcher>
  );
};

export default SiteRoute;
